import { render, staticRenderFns } from "./DeliveryEstimation.vue?vue&type=template&id=41316671&"
import script from "./DeliveryEstimation.vue?vue&type=script&lang=js&"
export * from "./DeliveryEstimation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports